angular
    .module("accordionToBeCorrected.components", [])
    .component("accordionToBeCorrected", {
        templateUrl: "ng/components/accordionToBeCorrected/accordionToBeCorrected.view.html",
        bindings: {
            inputModel: '<',
            outputModel: '=',
            correzioneOk: '&',
            correzioneKo: '&'
        },
        controllerAs: "accordionToBeCorrectedCtrl",
        controller: function accordionToBeCorrected(
            FileUploader,
            $configService,
            $rootScope,
            $timeout,
            $userService,
            $typeDomainService,
            $download
        ) {

            var self = this;

            self.uploader = new FileUploader({
                url: "",
                headers: {
                    "Access-Control-Allow-Origin": "*",
                    Token: "Bearer " + ($configService.getAppConfig().token || "no-token"),
                    "App-Name": $rootScope.portalName
                }
            });

            self.$onInit = function () {
                self.idInput = "";
                self.disabledInputDoc = {
                    ident: false,
                    cf: false,
                    docAgg: false
                }
                self.enabledTrashButton = {
                    ident: false,
                    cf: false,
                    docAgg: false
                }
                self.documentsUploaded = [];
                self.singleDocument = {
                    name: '',
                    type: '',
                    selected: false,
                    downloadLink: ''
                };

                self.typeDoc = "";

                self.idWfInstance = self.inputModel.idWfInstance;
                self.errorMessage = self.inputModel.metadataAppContractManualSignatureUploadDoc.errorMessage;
                self.model = {
                    note: self.note,
                    documentsUploaded: []
                }

                dealerUser();

            }


            var dealerUser = function () {

                $userService.getDealerUser()
                    .then(function (dealer) {
                        if (dealer) {
                            self.dealerUser = dealer;
                        }
                    });
            }




            self.check = function (el) {
                el.selected = !el.selected;
            };





            self.uploadDataFunc = function (type, inputNumber) {
                var document =
                    arguments.length > 3 && arguments[3] !== undefined ?
                        arguments[3] :
                        false;

                self.uploadDocumenti = document;
                self.singleDocument = {
                    name: '',
                    type: type,
                    selected: false,
                    downloadLink: ''
                };
                self.progresso = 0;
                self.idInput = inputNumber;
                self.typeDoc = type;
            };

            self.uploader.onAfterAddingFile = function (fileItem) {
                switch (self.typeDoc) {
                    case 'DOCIDENTITA':
                        self.disabledInputDoc = {
                            ident: true,
                            cf: false,
                            docAgg: false
                        }
                        break;
                    case 'CF':
                        self.disabledInputDoc = {
                            ident: false,
                            cf: true,
                            docAgg: false
                        }
                        break;
                    case '052':
                        self.disabledInputDoc = {
                            ident: false,
                            cf: false,
                            docAgg: true
                        }
                        break;
                }
                console.log("fileItem", fileItem);
                if (fileItem.file.size > 26214400) {
                    $rootScope.$broadcast("addAlert", {
                        text: "MAXIMUM_FILE_SIZE_EXCEEDED"
                    });
                    fileItem.remove();
                    $("#" + self.idInput).val("");
                }
                var fileName = fileItem.file.name;
                if (
                    fileName.toLowerCase().indexOf(".pdf") > -1 ||
                    fileName.toLowerCase().indexOf(".png") > -1 ||
                    fileName.toLowerCase().indexOf(".jpg") > -1 ||
                    fileName.toLowerCase().indexOf(".jpeg") > -1 ||
                    fileName.toLowerCase().indexOf(".p7m") > -1
                ) {

                    self.uploader.queue[0].progress = 100;
                    self.visualProgBar = true;
                    $timeout(function () {
                        self.progresso = 100;
                    }, 500);
                } else {
                    fileItem.remove();
                    $("#" + self.idInput).val("");
                    $rootScope.$broadcast("addAlert", {
                        text: "FORMAT_NOT_SUPPORTED"
                    });
                }
            };

            self.uploader.onAfterAddingAll = function (addedFileItems) {
                console.info("onAfterAddingAll", addedFileItems);
                self.finalUpload(self.uploadData);
            };

            self.uploader.onBeforeUploadItem = function (item) {
                item.file.name = window.encodeURIComponent(item.file.name);
                item.headers["Token"] = "Bearer " + $configService.getAppConfig().token;
                self.disableInput = true;
            };

            self.uploader.onProgressItem = function (fileItem, progress) {
                self.uploadCompleted = false;
            };

            self.uploader.onProgressAll = function (progress) { };

            self.uploader.onSuccessItem = function (
                fileItem,
                response,
                status,
                headers
            ) {
                self.loadingStatus.uploading = false;
            };

            self.uploader.onErrorItem = function (
                fileItem,
                response,
                status,
                headers
            ) {
                console.info("onErrorItem", fileItem, response, status, headers);
                //self.loadingStatus.uploading = false;
                $("#" + self.idInput).val("");
                $rootScope.$broadcast("addAlert", {
                    text: "ERROR_UPLOADING_FILE"
                });
                self.disableInput = false;
                $timeout(function () {
                    self.visualProgBar = false;
                }, 4000);

                fileItem.remove();

            };

            self.uploader.onCancelItem = function (
                fileItem,
                response,
                status,
                headers
            ) { };

            self.uploader.onCompleteItem = function (
                fileItem,
                response,
                status,
                headers
            ) {
                console.info("onCompleteItem", fileItem, response, status, headers);
                if (response && response.uploadFileServicePojo && response.uploadFileServicePojo.success) {
                    self.uploadOk = true;
                    console.log(fileItem);

                    self.singleDocument.name = response.uploadFileServicePojo.fileName;
                    self.singleDocument.downloadLink = self.generateDownloadLink(response.uploadFileServicePojo.fileName);

                    self.documentsUploaded.push(self.singleDocument);
                    self.enableButton();

                }
                self.uploader.queue = [];
                self.disableInput = false;
                $timeout(function () {
                    switch (self.typeDoc) {
                        case 'DOCIDENTITA':
                            self.disabledInputDoc = {
                                ident: false,
                                cf: false,
                                docAgg: false
                            }
                            break;
                        case 'CF':
                            self.disabledInputDoc = {
                                ident: false,
                                cf: false,
                                docAgg: false
                            }
                            break;
                        case '052':
                            self.disabledInputDoc = {
                                ident: false,
                                cf: false,
                                docAgg: false
                            }
                            break;
                    }
                }, 4000);
                $("#" + self.idInput).val("");
            };

            self.uploader.onCompleteAll = function () {
                console.info("onCompleteAll");
                self.uploadCompleted = true;
            };

            self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
                self.uploading = false;
            };

            self.finalUpload = function () {
                console.log("calling finalUpload");
                self.folderPath = "" + new Date().getTime();
                var url;
                if (self.typeDoc === "052") {
                    url =
                        $configService.getAppConfig().url +
                        "/uni/upload/service-infos/" +
                        encodeURIComponent(self.idWfInstance) +
                        "/052/IL";
                } else {
                    url =
                        $configService.getAppConfig().url +
                        "/uni/upload/service-infos/" +
                        encodeURIComponent(self.dealerUser.identifier) +
                        "/54e6297ba7f4c90ebc88e895eebe4f63/IL";
                }

                for (var int = 0; int < self.uploader.queue.length; int++) {
                    self.uploader.queue[int].url = url;
                }
                self.uploader.uploadAll();
            };


            self.deleteDocument = function (typeDoc) {
                switch (typeDoc) {
                    case 'DOCIDENTITA':
                        self.disabledInputDoc = {
                            ident: true,
                            cf: false,
                            docAgg: false
                        }
                        break;
                    case 'CF':
                        self.disabledInputDoc = {
                            ident: false,
                            cf: true,
                            docAgg: false
                        }
                        break;
                    case '052':
                        self.disabledInputDoc = {
                            ident: false,
                            cf: false,
                            docAgg: true
                        }
                        break;
                }
                self.progresso = 100;
                self.documentsToBeDeleted = self.documentsUploaded.filter(function (elem) {
                    return elem.selected == true;
                });

                self.documentsToBeDeleted.forEach(function (element) {
                    var type = 'IL'; //tipo di cancellazione es. IL – PERSONAL_DOCUMENT
                    var idObject = self.idWfInstance; // cf  oppure idWfInstance
                    var codiceDocNsil = '052'; //es: 052
                    var fileName = element.name; //nome del file

                    $typeDomainService.deleteFile(type, idObject, codiceDocNsil, fileName)
                        .then(function (response) {
                            console.log(response);
                            $timeout(function () {
                                self.enableButton();
                                self.progresso = 0;
                            }, 500);
                            $timeout(function () {
                                self.documentsUploaded = self.documentsUploaded.filter(function (element) {
                                    return element.selected != true || element.type != self.typeDoc;
                                });
                            }, 3400);
                            $timeout(function () {
                                switch (self.typeDoc) {
                                    case 'DOCIDENTITA':
                                        self.disabledInputDoc = {
                                            ident: false,
                                            cf: false,
                                            docAgg: false
                                        }
                                        break;
                                    case 'CF':
                                        self.disabledInputDoc = {
                                            ident: false,
                                            cf: false,
                                            docAgg: false
                                        }
                                        break;
                                    case '052':
                                        self.disabledInputDoc = {
                                            ident: false,
                                            cf: false,
                                            docAgg: false
                                        }
                                        break;
                                }
                            }, 5000)

                        })
                        .catch(function (error) {
                            $rootScope.$broadcast('addAlert', {
                                text: 'ERROR_TEC'
                            });
                        })
                        .finally(function () {

                            $timeout(function () {
                                self.visualProgBar = false;
                                self.uploadOk = false;
                            }, 4000);
                        })
                })



            }

            self.enabledTrashRemovePdf = function (type) {
                var x = self.documentsUploaded.filter(function (elem) {
                    return elem.selected === true;
                });
                if (x && x[0] && x[0].type) {
                    switch (x[0].type) {
                        case 'DOCIDENTITA':
                            self.enabledTrashButton.ident = true;
                            self.enabledTrashButton.cf = false;
                            self.enabledTrashButton.docAgg = false;

                            break;
                        case 'CF':
                            self.enabledTrashButton.ident = false;
                            self.enabledTrashButton.cf = true;
                            self.enabledTrashButton.docAgg = false;
                            break;
                        case '052':
                            self.enabledTrashButton.ident = false;
                            self.enabledTrashButton.docAgg = true;
                            self.enabledTrashButton.cf = false;

                            break;
                    }
                }

                return self.documentsUploaded.some(function (elem) {
                    return elem.selected === true;
                })

            }


            self.enableButton = function () {

                self.model = {
                    documentsUploaded: self.documentsUploaded,
                    note: self.note
                }

                if (self.documentsUploaded.length > 0) {

                    self.correzioneOk({
                        value: self.model
                    })
                } else {
                    self.correzioneKo({
                        value: self.model
                    })
                }


            }

            self.generateDownloadLink = function (filename) {
                var url =
                    "/uni/download/service-infos/" +
                    encodeURIComponent(self.idWfInstance) +
                    "/052/" +
                    filename +
                    "/IL/"

                $download.getGenericDownload(url)
                    .then(function (response) {
                        console.log(response);
                    })

            };

        }
    })